import { Component, OnInit, Input, ViewChild, ElementRef} from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';
import { LoaderService } from '../../../app/services/loader.service';
import { AppHelperService } from 'modules/app/services/app-helper.service';
import { ProductTocService } from 'modules/shared-postlogin/services/product-toc.service';
import { ContentAccessService } from 'modules/teacher/services/content-access.service';
import { ProductViewHelperService } from 'modules/shared-postlogin/services/product-view-helper.service';
import { nanoid } from 'nanoid';
import { ContentAccessHelperService } from 'modules/shared-postlogin/services/content-access-helper.service';
import { GenericErrorModal } from 'modules/teacher/components/generic-error-modal/generic-error-modal.component'
import { CustomBackendLoggerService } from 'modules/app/services/custom-backend-logger.service';
import { AuthService } from '../../../app/services/auth.service';

@Component({
    selector: 'create-access-rules',
    templateUrl: './create-access-rules.template.html',
    styleUrls: ['./create-access-rules.style.scss'],
    standalone: false
})
export class CreateAccessRules implements OnInit {
    paramsSubscription: Subscription;
    showSetRulePageSubscription: Subscription;
    itemsUpdatedAfterSetRuleInitiationSubscription: Subscription;
    @ViewChild('createRuleSuccessModal') createRuleSuccessModal: ElementRef;
    @ViewChild('openCreateRuleSuccessModal') openCreateRuleSuccessModal: ElementRef;
    @ViewChild('leaveSetRulePageModal') leaveSetRulePageModal: ElementRef;
    @ViewChild('openleaveSetRulePageModal') openleaveSetRulePageModal: ElementRef;
    @ViewChild(GenericErrorModal) private genericErrorModal: GenericErrorModal;
    @ViewChild('ruleSizeExceedButton') ruleSizeExceedButton: ElementRef;
    @Input() tocArray: any;
    @Input() ruleInfo: any;
    @Input() itemsAlreadyAssigned: any;
    public showAllRulesDetails: boolean = false;
    public tocFolderDepth: number;
    private spaceId: string;
    private productCode : string;
    private classId: string;
    public showLoader : boolean = false;
    public productData: any;
    public ruleStartDateMinValue;
    public currentDatetime;
    public showEndDateSelector: boolean = false;
    public selectedRuleType: string = '';
    public bundleTitle: string;
    public productTitle: string;
    public classStartDate: any;
    public classEndDate: any;
    public productRules: any;
    public ruleEndDateMinValue;
    public ruleStartDateMaxValue;
    public modifiedItemsLength: number;
    public noOfCheckedItems: number;
    public totalItemsInProduct: number;
    public showAssignmentsWarning: boolean = false;
    public showAssignmentsDetails: boolean = false;
    public noOfSelectedLearners: number = 0;
    public noOfLearnersInRule: number = 0;
    public isUserListUpdated: boolean = false;
    public unitConflictsMap: any = {};
    public lessonConflictsMap: any = {};
    public unitConflictsRulesMap: any = {};
    public lessonConflictsRulesMap: any = {};
    public showRulesWarning: boolean = false;
    public imageBasePath: string = IMAGES_BASEPATH;
    public usersList = [];
    public ruleData: any = {
        'ruleTitle': '',
        'ruleStartDate': '',
        'ruleEndDate': ''
    };
    public notificationsEnabled: any = {};
    public validNotificationsType: any = {
        beforeStartDate: false,
        onStartDate: false,
        beforeEndDate: false
    }
    public pluralMapping;
    public ruleLimitInComponent: number = parseInt(RULE_LIMIT_IN_COMPONENT);
    
    constructor(
        private route: ActivatedRoute,
        private loaderService: LoaderService,
        private productTocService: ProductTocService,
        private appHelperService: AppHelperService,
        private contentAccessService: ContentAccessService,
        private productViewHelperService: ProductViewHelperService,
        private contentAccessHelperService: ContentAccessHelperService,
        private customBackendLoggerService: CustomBackendLoggerService,
        private authService: AuthService
        ) {
            this.pluralMapping = this.appHelperService.pluralMapping;
        }

    ngOnInit() {
        if(this.route.snapshot.data.source !== 'CREATE_ACCESS_RULE') return;
        this.loaderService.hideLoader();
        this.productData = this.route.snapshot.data.resolveData.productData;
        this.productRules = this.productData.productRules;

        this.paramsSubscription = this.route.params.subscribe((params: Params) => {
            this.spaceId = params.spaceid;
            this.productCode = params.productcode;
            this.classId = params.classid;
            this.bundleTitle = this.productData.bundleDetails.title;
            this.classEndDate =  new Date(this.productData.classmeta.class.enddate);
            this.classStartDate =  this.convertStartTime(this.productData.classmeta.class.startdate);
            if (this.productData.classLearners.length) {
                this.productData.classLearners.forEach((user) => {
                    // By default students will be check on the page
                    if(!this.ruleInfo) {
                        user.isChecked = true;
                    }
                });
            }
            const bundleProduct = this.productData.bundleDetails.products.find( bP => bP['dls-product'] && bP['dls-product'].code === this.productCode);
            if (bundleProduct && bundleProduct.meta && bundleProduct.meta.title) {
                this.productTitle = bundleProduct.meta.title;
            }
        });
  
        this.currentDatetime = this.convertStartTime(Date.now()).getTime();
        this.setDateRange();
        this.tocFolderDepth = this.productTocService.getTocNodeCount(this.tocArray);
        this.ruleData.ruleStartDate = this.ruleStartDateMinValue;
        this.setvalidNotificationsType();
        // If this is the first rule, then by default lock rule will be selected
        this.selectedRuleType = this.productRules?.entities?.length === 0 ? 'lock' : '';

        // Filling existing rule details
        if(this.ruleInfo) {
            this.productRules.entities = this.productData.productRules.entities.filter(entity => entity.ruleid !== this.route.snapshot.params['ruleid']);
            this.fillExistingRuleInfo();
        }

        this.updateRuleInfo(this.productRules);

        this.showSetRulePageSubscription = this.productViewHelperService.showSetRulePageSubject.subscribe(data => {
            if(data.isVisible) {
                this.getAssignmentsConflictItems();
                this.getRulesConflictItems();
                if(data.totalItemsInProduct) this.totalItemsInProduct = data.totalItemsInProduct;
            }
            if(data.hasOwnProperty('totalCheckedItems')) this.noOfCheckedItems = data.totalCheckedItems;
        });

        // Event for modifications on set rule page
        this.itemsUpdatedAfterSetRuleInitiationSubscription = this.productViewHelperService.itemsUpdatedAfterSetRuleInitiationSubject.subscribe(data => {
            this.modifiedItemsLength = Object.keys(data).length;
        });

        if (!this.ruleInfo) this.noOfSelectedLearners = this.productData.classLearners.length;
    }

    handleShowEndDateInputKeydown(event) {
        event.preventDefault();
        event.target?.children[0].click();
    }

    showEndDateInput($event) {
        if ($event.target.checked) {
            this.showEndDateSelector = true;
        } else {
            this.showEndDateSelector = false;
            this.ruleData.ruleEndDate = '';
            this.ruleStartDateMaxValue = this.classEndDate;
        }
        this.setvalidNotificationsType();
    }

    setEndDateMinVal(event) {
        this.ruleEndDateMinValue = event.value;
        this.setvalidNotificationsType();
    }

    setvalidNotificationsType() {
        const oneDay = this.currentDatetime + (24 * 60 * 60 * 1000);
        if(new Date(this.ruleData.ruleStartDate).getTime() === this.currentDatetime) {
            this.validNotificationsType.onStartDate = true;
            this.validNotificationsType.beforeStartDate = false;
        }
        if(new Date(this.ruleData.ruleStartDate).getTime() < this.currentDatetime) {
            this.validNotificationsType.onStartDate = false;
            this.validNotificationsType.beforeStartDate = false;
        }
        if(new Date(this.ruleData.ruleStartDate).getTime() > this.currentDatetime) {
            if(oneDay < new Date(this.ruleData.ruleStartDate).getTime()) {
                this.validNotificationsType.beforeStartDate = true;
            } else {
                this.validNotificationsType.beforeStartDate = false;
            }
            this.validNotificationsType.onStartDate = true;
        }
        if(this.showEndDateSelector && this.ruleData.ruleEndDate && (oneDay < new Date(this.ruleData.ruleEndDate).getTime())) {
            this.validNotificationsType.beforeEndDate = true;
        } else  {
            this.validNotificationsType.beforeEndDate = false;
        }
        const existingNotificationsEnabled = (this.ruleInfo?.rule_display?.notificationsEnabled) || 
        (this.ruleInfo?.rule_data_common.notificationsEnabled) || {};

        // If notification didn't exist before, so it shouldn't exist now
        if (!this.validNotificationsType.beforeStartDate && !existingNotificationsEnabled['BEFORE-START-DATE']) {
            delete this.notificationsEnabled['BEFORE-START-DATE'];
        }
        if (!this.validNotificationsType.onStartDate && !existingNotificationsEnabled['START-DATE']) {
            delete this.notificationsEnabled['START-DATE'];
        }
        if (!this.validNotificationsType.beforeEndDate && !existingNotificationsEnabled['BEFORE-END-DATE']) {
            delete this.notificationsEnabled['BEFORE-END-DATE'];
        }
    }

    setStartDateMaxVal(event) {
        this.ruleStartDateMaxValue = event.value;
        this.setvalidNotificationsType();
    }

    trimSpaces() {
        this.ruleData.ruleTitle = this.ruleData.ruleTitle.replace(/^\s+/g, '');
    }

    clearRuleInfo() {
        this.ruleData = {
            'ruleTitle': '',
            'ruleStartDate': '',
            'ruleEndDate': ''
        };
        this.notificationsEnabled = {};
        // If this is the first rule, then by default lock rule will be selected
        this.selectedRuleType = this.productRules?.entities?.length === 0 ? 'lock' : '';
        this.showEndDateSelector = false;
        this.setvalidNotificationsType();
        if(this.ruleInfo) {
            this.fillExistingRuleInfo();
        } else {
            this.setDateRange();
            this.productData.classLearners.forEach(learner => {
                learner.isChecked = true;
            });
            this.noOfSelectedLearners = this.productData.classLearners.length;
            this.ruleData.ruleStartDate = this.ruleStartDateMinValue;
        }
    }

    public closeRuleSizeExceedModal() {
        this.ruleSizeExceedButton.nativeElement.click();
    }

    createRule() {
        this.showLoader = true;
        const scope  = this.noOfSelectedLearners === this.productData.classLearners.length ? 'GLOBAL-ALL-USERS' : 'USER';
        const data = this.getRuleBody('create', scope);
        data['ruleid'] = nanoid(16);
        const isRuleSizeValid = this.contentAccessHelperService.isRulesDocSizeValidForLearner(data,  this.productData, this.productRules);
        if (!isRuleSizeValid) {
            this.showLoader = false;
            this.ruleSizeExceedButton.nativeElement.click();

            this.customBackendLoggerService.logInfoToBackend({
                context: "ACCESS_RULES_SIZE_EXCEEDED;CREATE_RULE",
                extUserId: this.authService.getUserData().extUserId,
                spaceId: this.spaceId,
                classId: this.classId,
                productCode: this.productCode,
                data,
                isUserInfoNeeded: true,
            }).toPromise();

            return;
        }

        this.contentAccessService.createRule(this.spaceId, this.classId, this.productCode, data, this.classStartDate.getTime()).subscribe((res: any) => {
            if(res.success) {
                this.productRules.entities.push(data);
                if(data['scope'] === "GLOBAL-ALL-USERS") {
                    this.updateRuleInfo({ entities: [data] });
                }
                this.openCreateRuleSuccessModal.nativeElement.click();
            } else {
                this.genericErrorModal.showGenericErrorModal();
            }
            this.showLoader = false;
        }, _error => {
            this.genericErrorModal.showGenericErrorModal();
            this.showLoader = false;
        });
    }

    updateRule() {
        if(this.ruleData.ruleStartDate && this.ruleData.ruleEndDate) {
            if(this.ruleData.ruleEndDate < this.ruleData.ruleStartDate) return;
        }
        this.showLoader = true;
        let ruleData, isContextChanged = false;
        const scope = this.noOfSelectedLearners === this.productData.classLearners.length ? 'GLOBAL-ALL-USERS' : 'USER';
        if(this.ruleInfo.scope !== scope) {
            isContextChanged = true;
            ruleData = this.getRuleBody('create', scope);
            ruleData['ruleid'] = this.ruleInfo.ruleid;
        } else {
            ruleData = {
                updateData: this.getRuleBody('update', scope),
            };
            const isNotificationUpdated = !this.isContentStateSame(this.ruleInfo.rule_display.notificationsEnabled,this.notificationsEnabled);

            if(this.ruleData.ruleTitle !== (this.ruleInfo.rule_display?.title) || isNotificationUpdated) {
                ruleData['updateTitle'] = this.ruleData.ruleTitle;
                ruleData.notificationsEnabled = this.notificationsEnabled;
            }

        }

        const isRuleSizeValid = this.contentAccessHelperService.isRulesDocSizeValidForLearner(ruleData.updateData || ruleData, this.productData, this.productRules);
        
        if (!isRuleSizeValid) {
            this.showLoader = false;
            this.ruleSizeExceedButton.nativeElement.click();

            this.customBackendLoggerService.logInfoToBackend({
                context: "ACCESS_RULES_SIZE_EXCEEDED;UPDATE_RULE",
                extUserId: this.authService.getUserData().extUserId,
                spaceId: this.spaceId,
                classId: this.classId,
                productCode: this.productCode,
                data:ruleData,
                isUserInfoNeeded: true,
            }).toPromise();

            return;
        }

        const existingRuleData = {
            rule_data_common: this.ruleInfo.rule_data_common,
            rule_display: this.ruleInfo.rule_display
        };

        this.contentAccessService.updateRule(this.spaceId, this.classId, this.productCode, this.ruleInfo.ruleid, ruleData, this.classStartDate.getTime(), existingRuleData, isContextChanged).subscribe((res: any) => {
            if(res.success) {
                if(isContextChanged)  {
                    this.ruleInfo = ruleData;
                } else {
                    ruleData.updateData['ruleid'] = this.ruleInfo.ruleid;
                    if(this.ruleInfo.rule_display && this.ruleInfo.rule_display.title) {
                        ruleData.updateData['rule_display'] = {
                            title: this.ruleInfo.rule_display.title
                        };
                    }
                    if(this.ruleData.ruleTitle !== (this.ruleInfo.rule_display?.title)) {
                        ruleData.updateData['rule_display'] = {
                            title:  ruleData['updateTitle']
                        };
                    }

                    const ruleDisplay = ruleData.updateData['rule_display'] || {};
                    ruleDisplay.notificationsEnabled = this.notificationsEnabled;
                    ruleData.updateData['rule_display'] = ruleDisplay;

                    this.ruleInfo = ruleData.updateData;
                }
                this.fillExistingRuleInfo();
                this.openCreateRuleSuccessModal.nativeElement.click();
            } else {
                this.genericErrorModal.showGenericErrorModal();
            }
            this.showLoader = false;
        }, _error => {
            this.genericErrorModal.showGenericErrorModal();
            this.showLoader = false;
        });
        
    }

    private getContentForRule() {
        const entities = [];
        const updateRulesEntity = item => {
            entities.push({
                id: item['item-code'],
                type: item['item-type']
            });
        }
        if(this.noOfCheckedItems === this.totalItemsInProduct) {
            updateRulesEntity({
                'item-code': this.productCode,
                'item-type': 'product'
            });
        } else {
            if(this.tocFolderDepth === 0) {
                this.tocArray.forEach((item) => {
                    if(item.isChecked) {
                        updateRulesEntity(item);
                    }
                });
            } 
            else {
                this.tocArray.forEach(unit => {
                    if(unit.checkedItems !== 0 && unit.checkedItems === unit.totalItems) {
                        updateRulesEntity(unit);
                    } else {
                        const unitLessons = this.productTocService.getLastFolderData(unit);
                        unitLessons.forEach(lesson => {
                            if(lesson.checkedItems !== 0 && lesson.checkedItems === lesson.items.length) {
                                updateRulesEntity(lesson);
                            } else {
                                lesson.items.forEach(item => {
                                    if(item.isChecked) {
                                        updateRulesEntity(item);
                                    }
                                }) 
                            }
                        });
                    }
                });
            }
        }
        return entities;
    }

    private getRuleBody(action, scope) {
        const data = {
            entities: this.getContentForRule(),
            rule_data_common: {
                access: this.selectedRuleType
            },
            scope
        };

        if(action === 'create') {
            data['rule_display'] = {};
            data['spaceid'] = this.spaceId;
            if(this.ruleData.ruleTitle) {
                data['rule_display'].title = this.ruleData.ruleTitle;
            }
            if(Object.keys(this.notificationsEnabled).length) {
                data['rule_display'].notificationsEnabled = this.notificationsEnabled;
            }
        }
        
        if(scope === 'USER') {
            data['user'] = [];
            this.productData.classLearners.forEach(learner => {
                if(learner.isChecked) {
                    data['user'].push(learner.userid);
                }
            });
        }

        if(this.ruleData?.ruleStartDate !== this.classStartDate) {
            data.rule_data_common['startTime'] = this.convertStartTime(new Date(this.ruleData.ruleStartDate).getTime()).getTime();
        }

        if(this.ruleData.ruleEndDate && this.showEndDateSelector) {
            data.rule_data_common['endTime'] = this.convertEndTime(new Date(this.ruleData.ruleEndDate).getTime()).getTime();
        }
        return data;
    }

    navigateToManageAccessPage(openNewTab = false) {
        if (openNewTab) window.open(`/class/teacher/${this.spaceId}/class/${this.classId}/bundle/${this.productData.bundleDetails['bundle-code']}/manage-access`, '_blank');
        else this.appHelperService.navigateToClassApp(['teacher', this.spaceId, 'class', this.classId, 'bundle', this.productData.bundleDetails['bundle-code'], 'manage-access']);
    }

    createAnotherRule() {
        const isMQASchool = this.productData.orgId.indexOf("mqa") === 0;
        const createAccessProducts = this.contentAccessService.getCreateAccessComponents(this.productData.classmeta, this.productData.bundleDetails['bundle-code'], isMQASchool);
        if(createAccessProducts.length > 1) {
            this.appHelperService.navigateToClassApp(['teacher', this.spaceId, 'class', this.classId, 'bundle', this.productData.bundleDetails['bundle-code'], 'manage-access', 'create']);
        } else {
            this.clearRuleInfo();
            this.productViewHelperService.resetTocSelectionSubject.next(true);
            this.productViewHelperService.showSetRulePageSubject.next({
                isVisible: false
            });
        }
    }

    navigateToAssignmentsView() {
        window.open(`/class/teacher/${this.spaceId}/class/${this.classId}/view/assignments`, '_blank');
    }

    getAssignmentsConflictItems() {
        const getRulesConflictItemsData = this.contentAccessHelperService.getRulesConflictItems(this.tocArray, this.tocFolderDepth, {isAssignmentCheck: true, itemsAlreadyAssigned: this.itemsAlreadyAssigned});
        this.unitConflictsMap = getRulesConflictItemsData.unitConflictsMap;
        this.lessonConflictsMap = getRulesConflictItemsData.lessonConflictsMap;
        this.showAssignmentsWarning = getRulesConflictItemsData.showWarning;
    }

    private fillExistingRuleInfo() {
        this.noOfLearnersInRule = 0;
        this.isUserListUpdated = false;
        this.selectedRuleType = this.ruleInfo.rule_data_common.access;
        if(this.ruleInfo.rule_data_common.startTime) {
            this.ruleData.ruleStartDate = new Date(this.ruleInfo.rule_data_common.startTime);
        } else {
            this.ruleData.ruleStartDate = this.classStartDate;
        }
        if(this.ruleInfo.rule_data_common.endTime) {
            this.ruleData.ruleEndDate = new Date(this.ruleInfo.rule_data_common.endTime);
            this.showEndDateSelector = true;
            this.ruleStartDateMaxValue = this.ruleData.ruleEndDate;
        }
        if (new Date(this.classStartDate).getTime() > this.currentDatetime) {
            this.ruleStartDateMinValue = this.classStartDate;
        } else {
            this.ruleStartDateMinValue = new Date(this.currentDatetime);
        }
        this.setvalidNotificationsType();
        this.notificationsEnabled = {};
        const ruleInfoNotifications = this.ruleInfo.rule_display.notificationsEnabled || this.ruleInfo.rule_data_common.notificationsEnabled;
        if(ruleInfoNotifications) {
            for(const notificationType of Object.keys(ruleInfoNotifications)) {
                this.notificationsEnabled[notificationType] = true;
            }
        }
        this.ruleEndDateMinValue = this.ruleData.ruleStartDate;
        if(this.ruleInfo.rule_display && this.ruleInfo.rule_display.title) this.ruleData.ruleTitle = this.ruleInfo.rule_display.title;
        this.productData.classLearners.forEach((user) => {
            // By default students will be check on the page
            if((this.ruleInfo['scope'] === "GLOBAL-ALL-USERS") || this.ruleInfo['scope'] === "USER" && this.ruleInfo.user.indexOf(user.userid) !== -1 ) {
                user.isChecked = true;
                this.noOfLearnersInRule++;
            } else if(user.isChecked) user.isChecked = false;
        });
        this.noOfSelectedLearners = this.noOfLearnersInRule;
    }

    isChangesMade() {
        if(this.ruleInfo) {
            return this.selectedRuleType !== this.ruleInfo.rule_data_common.access ||
            (!this.ruleInfo.rule_display.title && this.ruleData.ruleTitle !== '') || (this.ruleInfo.rule_display.title && this.ruleInfo.rule_display.title !== this.ruleData.ruleTitle) || 
            (!this.ruleInfo.rule_data_common.startTime && this.ruleData.ruleStartDate !== this.classStartDate) || 
            (this.ruleInfo.rule_data_common.startTime && new Date(this.ruleData.ruleStartDate).getTime() !== this.ruleInfo.rule_data_common.startTime) || 
            (!this.ruleInfo.rule_data_common.endTime && this.showEndDateSelector && this.ruleData.ruleEndDate) || 
            (this.ruleInfo.rule_data_common.endTime && ((new Date(this.ruleData.ruleEndDate).getTime() !== this.ruleInfo.rule_data_common.endTime) || !this.showEndDateSelector)) || 
            !this.isContentStateSame(this.getContentForRule(), this.ruleInfo.entities) || this.isUserListUpdated ||
            ((this.ruleInfo.rule_display.notificationsEnabled || this.ruleInfo.rule_data_common.notificationsEnabled) &&
            !this.isContentStateSame(this.ruleInfo.rule_display.notificationsEnabled || this.ruleInfo.rule_data_common.notificationsEnabled , this.notificationsEnabled));
        }

        const isRuleTypeChanged = this.productRules?.entities?.length === 0 ? this.selectedRuleType !== 'lock' : this.selectedRuleType !== '';
        
        return isRuleTypeChanged || this.ruleData.ruleTitle || (this.ruleData.ruleStartDate && this.ruleData.ruleStartDate !== this.ruleStartDateMinValue) || (this.showEndDateSelector && this.ruleData.ruleEndDate) || (this.productData.classLearners.length !== 0 && this.noOfSelectedLearners !== this.productData.classLearners.length || Object.keys(this.notificationsEnabled).length);
    }

    leaveSetRulePageWithoutSaving() {
        this.productViewHelperService.leaveSetRulePage.next(true);
    }

    navigateBack() {
        if(this.isChangesMade() && this.noOfCheckedItems !== 0) {
            this.openleaveSetRulePageModal.nativeElement.click();
        } else {
            this.leaveSetRulePageWithoutSaving();
        }
    }

    /* Helper function to compare objects */
    isContentStateSame(obj1, obj2) {
        const compare = (obj1, obj2) => {
  
          const obj1Type = Object.prototype.toString.call(obj1);
          const obj2Type = Object.prototype.toString.call(obj2);
  
          if(obj1Type !== obj2Type) {
              return false;
          } else if(obj1Type === '[object Object]') {
            if(Object.keys(obj1).length !== Object.keys(obj2).length) {
                return false;
            }
            for(const key in obj1) {
                if(obj1.hasOwnProperty(key)) {
                    if(obj2.hasOwnProperty(key)) {
                        if(!compare(obj1[key], obj2[key])) {
                        return false;
                        }
                    } else {
                    return false;
                    }
                }
            }
          } else if(obj1Type === '[object Array]') {
                if(obj1.length !== obj2.length) {
                    return false;
                }
                for(let i = 0; i < obj1.length; i++) {
                if(!compare(obj1[i], obj2[i])) {
                    return false;
                }
            }
          } else {
            if(obj1 !== obj2) {
                return false;
            }
          }
          return true;
        };
        return compare(obj1, obj2);
    }

    setDateRange() {
        this.ruleStartDateMaxValue = this.classEndDate;
        if (this.classStartDate.getTime() < this.currentDatetime) {
            this.ruleStartDateMinValue = this.ruleEndDateMinValue =  new Date(this.currentDatetime);
        } else {
            this.ruleStartDateMinValue = this.ruleEndDateMinValue = this.classStartDate;
        }
    }

    updateRuleInfo(data) {
        const ruleMap = this.contentAccessHelperService.createRulesMap(
            data,
            this.productData.classmeta.class.startdate,
            this.productData.classmeta.class.enddate
        );
        this.contentAccessHelperService.collectRulesOnItem(ruleMap, this.tocArray, this.tocFolderDepth, this.productCode);
    }

    getRulesConflictItems() {
        const getRulesConflictItemsData = this.contentAccessHelperService.getRulesConflictItems(this.tocArray, this.tocFolderDepth);
        this.unitConflictsRulesMap = getRulesConflictItemsData.unitConflictsMap;
        this.lessonConflictsRulesMap = getRulesConflictItemsData.lessonConflictsMap;
        this.showRulesWarning = getRulesConflictItemsData.showWarning;
    }

    handleSelectLearnerKeydown(event) {
        event.preventDefault();
        event.target?.children[0].click();
    }

    selectLearner($event, learner) {
        if ($event.currentTarget.checked) {
            learner.isChecked = true;
            this.noOfSelectedLearners++;
        } else {
            learner.isChecked = false;
            this.noOfSelectedLearners--;
        }
        if(this.ruleInfo) this.updateUserListStatus(learner);
    }

    handleSelectAllLearnersKeydown(event) {
        event.preventDefault();
        event.target?.children[0].click();
    }

    selectAllLearners($event) {
        if (!$event.currentTarget.checked || (this.noOfSelectedLearners !== 0 && this.noOfSelectedLearners !== this.productData.classLearners.length)) {
            this.productData.classLearners.forEach(learner => {
                if (learner.isChecked) {
                    learner.isChecked = false;
                    this.noOfSelectedLearners--;
                }
                if(this.ruleInfo) this.updateUserListStatus(learner);
            });
            $event.target.checked = false;
            $event.target.indeterminate = false;
        } else {
            this.productData.classLearners.forEach(learner => {
                if (!learner.isChecked) {
                    learner.isChecked = true;
                    this.noOfSelectedLearners++;
                }
                if(this.ruleInfo) this.updateUserListStatus(learner); 
            });
            $event.target.checked = true;
            $event.target.indeterminate = false;
        }
    }

    handleNotifiactionTypeKeydown(event) {
        event.preventDefault();
        event.target?.children[0].click();
    }

    selectNotificationType($event, notificationType) {
        if ($event.currentTarget.checked) {
            if(notificationType === 'beforeStartDate') this.notificationsEnabled['BEFORE-START-DATE'] = true;
            if(notificationType === 'onStartDate') this.notificationsEnabled['START-DATE'] = true;
            if(notificationType === 'beforeEndDate') this.notificationsEnabled['BEFORE-END-DATE'] = true;
        } else {
            if(notificationType === 'beforeStartDate') delete this.notificationsEnabled['BEFORE-START-DATE'];
            if(notificationType === 'onStartDate') delete this.notificationsEnabled['START-DATE'];
            if(notificationType === 'beforeEndDate') delete this.notificationsEnabled['BEFORE-END-DATE'];
        }
    }
    
    convertStartTime(timestamp) {
        const date = new Date(timestamp);
        date.setSeconds(0);
        date.setMilliseconds(0);
        return date;
    }

    convertEndTime(timestamp) {
        const date = new Date(timestamp);
        date.setSeconds(59);
        date.setMilliseconds(999);
        return date;
    }

    updateUserListStatus(learner) {
        this.isUserListUpdated = this.noOfLearnersInRule !== this.noOfSelectedLearners || (this.ruleInfo.scope === 'USERS' && ((!learner.isChecked && this.ruleInfo.user.indexOf(learner.userid) !== -1) || (learner.isChecked && this.ruleInfo.user.indexOf(learner.userid) === -1)));
    }

    ngOnDestroy() {
        if (this.paramsSubscription) {
            this.paramsSubscription.unsubscribe();
        }
        if(this.itemsUpdatedAfterSetRuleInitiationSubscription) {
            this.itemsUpdatedAfterSetRuleInitiationSubscription.unsubscribe();
        }
        if(this.showSetRulePageSubscription) {
            this.showSetRulePageSubscription.unsubscribe();
        }
        if (this.createRuleSuccessModal.nativeElement.classList.contains('show')) {
            this.openCreateRuleSuccessModal.nativeElement.click();
        }
        if(this.leaveSetRulePageModal.nativeElement.classList.contains('show')) {
            this.openleaveSetRulePageModal.nativeElement.click();
        }
    }
}